import { render, staticRenderFns } from "./PersonelTurleriList.vue?vue&type=template&id=6d7acb76"
import script from "./PersonelTurleriList.vue?vue&type=script&lang=ts"
export * from "./PersonelTurleriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports